"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useValueAsStream = exports.useChangeValueEffect = exports.useStateAsStream = exports.useEventAsStream = exports.useVoidEventAsStream = exports.useStreamValue = exports.useStreamEffect = exports.useDataStream = exports.useStream = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var custom_operators_1 = require("./custom/custom-operators");
var useStream = function (stream$) {
    var ref = (0, react_1.useRef)(stream$.pipe((0, operators_1.shareReplay)(1)));
    return ref.current;
};
exports.useStream = useStream;
var useDataStream = function (initialValue, stream$) {
    return (0, exports.useStream)(stream$.pipe((0, operators_1.startWith)(initialValue), (0, custom_operators_1.skipUnchangedImmutable)()));
};
exports.useDataStream = useDataStream;
var useStreamEffect = function (stream$, subscriptionFn) {
    var ref = (0, react_1.useRef)({ stream$: stream$, subscriptionFn: subscriptionFn });
    (0, react_1.useEffect)(function () {
        var s = ref.current.stream$.subscribe(ref.current.subscriptionFn);
        return function () {
            s.unsubscribe();
        };
    }, []);
};
exports.useStreamEffect = useStreamEffect;
// Wraps the value with an object to avoid setState's update behavior when T is function type.
var useStreamValue = function (stream$, initialValue) {
    var _a;
    var _b = tslib_1.__read((0, react_1.useState)({
        value: initialValue
    }), 2), state = _b[0], setState = _b[1];
    (0, exports.useStreamEffect)(stream$, function (value) { return setState({ value: value }); });
    return (_a = state.value) !== null && _a !== void 0 ? _a : initialValue;
};
exports.useStreamValue = useStreamValue;
var useVoidEventAsStream = function () {
    var src$ = (0, react_1.useRef)(new rxjs_1.Subject());
    var emitter = (0, react_1.useCallback)(function () {
        src$.current.next();
    }, []);
    var event$ = (0, exports.useStream)(src$.current.asObservable());
    return [event$, emitter];
};
exports.useVoidEventAsStream = useVoidEventAsStream;
var useEventAsStream = function () {
    var src$ = (0, react_1.useRef)(new rxjs_1.Subject());
    var emitter = (0, react_1.useCallback)(function (value) {
        src$.current.next(value);
    }, []);
    var event$ = (0, exports.useStream)(src$.current.asObservable());
    return [event$, emitter];
};
exports.useEventAsStream = useEventAsStream;
var useStateAsStream = function (initialValue) {
    var src$ = (0, react_1.useRef)(new rxjs_1.BehaviorSubject(initialValue));
    var setter = (0, react_1.useCallback)(function (v) {
        src$.current.next(v);
    }, []);
    var value$ = (0, exports.useStream)(src$.current.asObservable());
    return [value$, setter];
};
exports.useStateAsStream = useStateAsStream;
var useChangeValueEffect = function (input, callback) {
    (0, react_1.useEffect)(function () {
        callback(input);
    }, [input, callback]);
};
exports.useChangeValueEffect = useChangeValueEffect;
var useValueAsStream = function (input) {
    var _a = tslib_1.__read((0, exports.useStateAsStream)(input), 2), value$ = _a[0], setValue = _a[1];
    (0, exports.useChangeValueEffect)(input, setValue);
    return value$;
};
exports.useValueAsStream = useValueAsStream;
